/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAccessConfigIn } from '../models/CustomerAccessConfigIn';
import type { CustomerAccessInviteIn } from '../models/CustomerAccessInviteIn';
import type { CustomerAccessInviteOut } from '../models/CustomerAccessInviteOut';
import type { CustomerAccessOut } from '../models/CustomerAccessOut';
import type { CustomerAccessRevokeIn } from '../models/CustomerAccessRevokeIn';
import type { CustomerProjectSummaryOut } from '../models/CustomerProjectSummaryOut';
import type { Paginated_ProjectListItem_ } from '../models/Paginated_ProjectListItem_';
import type { ProjectOut } from '../models/ProjectOut';
import type { ProjectOverviewStatsOut } from '../models/ProjectOverviewStatsOut';
import type { ProjectPatch } from '../models/ProjectPatch';
import type { ProjectQaQcSettings } from '../models/ProjectQaQcSettings';
import type { ProjectQaQcSettingsUpdate } from '../models/ProjectQaQcSettingsUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProjectsService {
    /**
     * List Projects
     * @returns Paginated_ProjectListItem_ Successful Response
     * @throws ApiError
     */
    public static listProjectsProjectsGet({
        search,
        stage,
        sort = 'customer_name',
        includeArchived = false,
        page = 1,
        pageSize = 20,
    }: {
        /**
         * Case-insensitive substring over native/customer/project name
         */
        search?: (string | null),
        /**
         * Filter by stage: "active" | "completed" | omit/all
         */
        stage?: (string | null),
        /**
         * Sort key; prefix with '-' for descending. See PROJECT_SORT_COLUMNS.
         */
        sort?: string,
        /**
         * Include archived projects. Hidden by default.
         */
        includeArchived?: boolean,
        page?: number,
        pageSize?: number,
    }): CancelablePromise<Paginated_ProjectListItem_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects',
            query: {
                'search': search,
                'stage': stage,
                'sort': sort,
                'include_archived': includeArchived,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Project
     * @returns ProjectOut Successful Response
     * @throws ApiError
     */
    public static getProjectProjectsProjectIdGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<ProjectOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Project
     * @returns ProjectOut Successful Response
     * @throws ApiError
     */
    public static patchProjectProjectsProjectIdPatch({
        projectId,
        requestBody,
    }: {
        projectId: number,
        requestBody: ProjectPatch,
    }): CancelablePromise<ProjectOut> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/projects/{project_id}',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Archive Project
     * @returns ProjectOut Successful Response
     * @throws ApiError
     */
    public static archiveProjectProjectsProjectIdArchivePost({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<ProjectOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/archive',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Customer Access
     * @returns CustomerAccessOut Successful Response
     * @throws ApiError
     */
    public static listCustomerAccessProjectsProjectIdCustomerAccessGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<Array<CustomerAccessOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/customer-access',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Invite Customer Access
     * @returns CustomerAccessInviteOut Successful Response
     * @throws ApiError
     */
    public static inviteCustomerAccessProjectsProjectIdCustomerAccessInvitationsPost({
        projectId,
        requestBody,
    }: {
        projectId: number,
        requestBody: CustomerAccessInviteIn,
    }): CancelablePromise<CustomerAccessInviteOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/customer-access/invitations',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Customer Recipients
     * @returns CustomerAccessOut Successful Response
     * @throws ApiError
     */
    public static updateCustomerRecipientsProjectsProjectIdCustomerAccessRecipientsPut({
        projectId,
        requestBody,
    }: {
        projectId: number,
        requestBody: CustomerAccessConfigIn,
    }): CancelablePromise<Array<CustomerAccessOut>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/customer-access/recipients',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Customer Access
     * @returns void
     * @throws ApiError
     */
    public static revokeCustomerAccessProjectsProjectIdCustomerAccessRevokePost({
        projectId,
        requestBody,
    }: {
        projectId: number,
        requestBody: CustomerAccessRevokeIn,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/customer-access/revoke',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Customer Project Summary
     * @returns CustomerProjectSummaryOut Successful Response
     * @throws ApiError
     */
    public static getCustomerProjectSummaryProjectsProjectIdCustomerSummaryGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<CustomerProjectSummaryOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/customer-summary',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Project Overview Stats
     * @returns ProjectOverviewStatsOut Successful Response
     * @throws ApiError
     */
    public static getProjectOverviewStatsProjectsProjectIdOverviewStatsGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<ProjectOverviewStatsOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/overview-stats',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Project Qaqc Settings
     * @returns ProjectQaQcSettings Successful Response
     * @throws ApiError
     */
    public static getProjectQaqcSettingsProjectsProjectIdQaqcSettingsGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<ProjectQaQcSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/projects/{project_id}/qaqc-settings',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Project Qaqc Settings
     * @returns ProjectQaQcSettings Successful Response
     * @throws ApiError
     */
    public static updateProjectQaqcSettingsProjectsProjectIdQaqcSettingsPut({
        projectId,
        requestBody,
    }: {
        projectId: number,
        requestBody: ProjectQaQcSettingsUpdate,
    }): CancelablePromise<ProjectQaQcSettings> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/projects/{project_id}/qaqc-settings',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Restore Project
     * @returns ProjectOut Successful Response
     * @throws ApiError
     */
    public static restoreProjectProjectsProjectIdRestorePost({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<ProjectOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/projects/{project_id}/restore',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
